module.exports = __webpack_public_path__ + "static/media/draft_icon.be081e7a.png";